import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function EditSeason() {
  const { id } = useParams();
  const [name, setName] = useState("");
  const [slug, setSlug] = useState("");
  const [is_active, setIsActive] = useState("1");
  const navigate = useNavigate();

  const generateSlug = (text) => {
    return text
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9\s-]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-");
  };

  // Fetch season data
  useEffect(() => {
    fetch(`https://coombb.com/backend/api/seasons/${id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        // Authorization: `Bearer ${localStorage.getItem("token")}`
      },
    })
      .then((res) => res.json())
      .then((data) => {
        const season = data.data[0];
        setName(season.name || "");
        setSlug(season.slug || "");
        setIsActive(season.is_active?.toString() || "1");
      })
      .catch((err) => {
        console.error("Error loading season:", err);
        toast.error("Failed to load season details ❌");
      });
  }, [id]);

  // Auto-update slug when name changes
  useEffect(() => {
    setSlug(generateSlug(name));
  }, [name]);

  const handleUpdate = (e) => {
    e.preventDefault();

    const updatedSeason = {
      name,
      slug,
      is_active: parseInt(is_active),
    };

    fetch(`https://coombb.com/backend/api/seasons/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        // Authorization: `Bearer ${localStorage.getItem("token")}`
      },
      body: JSON.stringify(updatedSeason),
    })
      .then(async (res) => {
        const data = await res.json();

        // ❌ Handle HTTP errors
        if (!res.ok) {
          throw new Error(data.message || "Failed to update season");
        }

        return data;
      })
      .then((data) => {
        console.log("API Response:", data);

        // ✅ Handle backend success flag
        if (data.success) {
          toast.success(data.message || "Season updated successfully!", {
            position: "top-right",
            autoClose: 2000,
          });

          setTimeout(() => {
            navigate("/seasons");
          }, 2200);
        } else {
          // ❌ API responded but success = false
          toast.error(data.message || "Failed to update season ❌", {
            position: "top-right",
            autoClose: 3000,
          });

          // Optional: validation errors
          if (data.errors) {
            Object.values(data.errors).forEach((errArr) => {
              toast.error(errArr[0]);
            });
          }
        }
      })
      .catch((err) => {
        console.error("Error updating season:", err);

        toast.error(err.message || "Something went wrong ❌", {
          position: "top-right",
          autoClose: 3000,
        });
      });
  };

  return (
    <div className="max-w-2xl mx-auto dark:bg-gray-900 shadow-md rounded-lg p-6 mt-6">
      <h2 className="text-2xl font-bold mb-6 dark:text-white">Edit Season</h2>

      <form onSubmit={handleUpdate} className="space-y-5">
        {/* Season Name */}
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-white mb-1">
            Season Name
          </label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
            className="w-full border border-gray-300 dark:border-gray-700 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        {/* Slug */}
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-white mb-1">
            Slug
          </label>
          <input
            type="text"
            value={slug}
            onChange={(e) => setSlug(generateSlug(e.target.value))}
            required
            readOnly
            className="w-full border border-gray-300 dark:border-gray-700 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        {/* Status (is_active) */}
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Status
          </label>
          <select
            value={is_active}
            onChange={(e) => setIsActive(e.target.value)}
            className="w-full border border-gray-300 dark:border-gray-700 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="1">Active</option>
            <option value="0">Inactive</option>
          </select>
        </div>

        {/* Submit Button */}
        <button
          type="submit"
          className="bg-red-600 hover:bg-red-700 text-white font-medium px-5 py-2 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-red-400"
        >
          Update Season
        </button>
      </form>

      <ToastContainer />
    </div>
  );
}
